import { render, staticRenderFns } from "./voyage_pl.vue?vue&type=template&id=48575e56&scoped=true"
import script from "./voyage_pl.vue?vue&type=script&lang=js"
export * from "./voyage_pl.vue?vue&type=script&lang=js"
import style0 from "./voyage_pl.vue?vue&type=style&index=0&id=48575e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48575e56",
  null
  
)

export default component.exports